import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import { Icon, Form, Input, Button } from 'semantic-ui-react';
import { create } from '../../../actions/unidade';
import { findByDocumento as findResponsavelByDocumento } from '../../../actions/responsavel';
import * as FormValidator from '../../../utils/formValidator';
import * as Formatador from '../../../utils/formatador';
import Erro from '../../layouts/mensagens/Erro';
import InputMask from 'react-text-mask';
import api from '../../../api';
import { CabecalhoForm, SecaoForm, OpcaoForm, AvisoForm, RodapeForm } from '../../layouts/FormUI';

class CadastrarUnidade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      habilitado: true,
      condominio: {},
      unidade: {
        bloco: "",
        numero: "",
        descricao: "",
        condominio: "",
        ativo: true,
        bloqueadoVotacao: false,
        fracao: 1,
        responsavel: {
          documento: "",
          nome: "",
          email: "",
          celular: "",
        },
      },
      errors: {},
      errorsResponsavel: {},
      sucesso: false,
      loading: false,
      loadingResponsavel: false,
      responsavelExists: false,
    };
    this.pararBusca = this.pararBusca.bind(this);
  }

  componentDidMount = async () => {
    try {
      const condominio = await api.condominio.findSimpleById(this.props.match.params.id);
      const habilidado = await api.unidade.validarQuantidade(condominio._id).then(it => it.habilitado);

      this.setState({
        habilidado,
        condominio,
        loading: false,
        unidade: {
          ...this.state.unidade,
          condominio: condominio._id,
        },
      });
    } catch (e) {
      this.setState({
        loading: false,
        errors: (e.data && e.data.errors) || {},
      });
    }
  };

  onChange = (e) => {
    this.setState({
      unidade: { ...this.state.unidade, [e.target.name]: e.target.value },
      errors: {},
    });
  };

  onChangeTokenEmail = () => {
    this.setState({
      unidade: {
        ...this.state.unidade,
        enviarTokenEmail: !this.state.unidade.enviarTokenEmail,
      },
      errors: {},
    });
  };

  onChangeResponsavel = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === 'documento') {
      const documento =
        Formatador.removerChars(value).toString().length > 14
          ? Formatador.removerChars(value)
              .toString()
              .slice(0, 14)
          : Formatador.removerChars(value).toString();

      const tipoDocumento = documento.length > 11 ? 'CNPJ' : 'CPF';

      this.setState({
        unidade: {
          ...this.state.unidade,
          responsavel: {
            ...this.state.unidade.responsavel,
            nome: '',
            documento,
            tipoDocumento,
          },
        },
        errors: {},
        errorsResponsavel: {},
      });

      this.findResponsavelByDocumento(documento);
    } else {
      this.setState({
        unidade: {
          ...this.state.unidade,
          responsavel: {
            ...this.state.unidade.responsavel,
            [name]: value,
          },
        },
        errors: {},
        errorsResponsavel: {},
      });
    }
  };

  pararBusca() {
    clearTimeout(this.state.busca);
  }

  findResponsavelByDocumento = (documento) => {
    const buscar = async () => {
      await this.props.findResponsavelByDocumento(documento);
      this.setState({
        unidade: {
          ...this.state.unidade,
          responsavel: FormValidator.objIsEmpty(this.props.errors)
            ? {
                ...this.state.unidade.responsavel,
                nome: this.props.responsavel.nome,
                documento,
              }
            : { ...this.props.responsavel, documento },
        },
        errorsResponsavel: this.props.errorsResponsavel,
        loadingResponsavel: false,
        responsavelExists: FormValidator.objIsEmpty(
          this.props.errorsResponsavel
        ),
        errors: this.props.errors,
      });
    };
    const responsavel = this.state.unidade.responsavel;
    if (documento.length === 11 && !FormValidator.isCpf(documento))
      this.setState({ errorsResponsavel: { documento: 'CPF inválido' } });

    if (documento !== responsavel.documento) {
      this.pararBusca();
      if (FormValidator.isCpf(documento) || FormValidator.isCnpj(documento)) {
        this.setState({ loadingResponsavel: true, responsavelExists: false });
        this.setState({
          busca: setTimeout(function() {
            buscar();
          }, 1500),
        });
      } else {
        this.setState({
          loadingResponsavel: false,
          responsavelExists:
            FormValidator.isCpf(documento) || FormValidator.isCnpj(documento),
        });
      }
    }
  };

  validate = (unidade) => {
    const errors = {};
    const { condominio } = this.state;

    if (FormValidator.isVazio(unidade.numero)) {
      errors.numero = 'Número é obrigatório';
    }

    if (condominio && condominio.usarFracaoIdeal && !unidade.fracao) {
      errors.fracao = 'Fração é obrigatório';
    }

    if (FormValidator.isVazio(unidade.responsavel.documento.replace(/\D/g, ''))) {
      errors.documento = 'Responsável obrigatório';
    } else if (!FormValidator.isCpf(unidade.responsavel.documento) &&
               !FormValidator.isCnpj(unidade.responsavel.documento)) {
      errors.documento = 'Documento inválido';
    }

    if (!this.state.responsavelExists) {
      if (FormValidator.isVazio(unidade.responsavel.nome) ||
          !FormValidator.isNomeCompleto(unidade.responsavel.nome)) {
        errors.nome = 'Digite o nome completo';
      }

      if (!FormValidator.isVazio(unidade.responsavel.email) &&
          !FormValidator.isEmail(unidade.responsavel.email)) {
        errors.email = 'Insira um email válido';
      }

      if (!FormValidator.isVazio(unidade.responsavel.celular.replace(/\D/g, '')) &&
          !FormValidator.isNumeroCelular(unidade.responsavel.celular)) {
        errors.celular = 'Celular inválido';
      }
    }

    return errors;
  };

  onSubmitCadastrar = async (e) => {
    e.preventDefault();

    const errors = this.validate(this.state.unidade);
    this.setState({ errors });

    if (FormValidator.objIsEmpty(errors)) {
      this.setState({ loading: true });

      try {
        await api.unidade.create(this.state.unidade);
        this.setState({ loading: false, sucesso: true, errors: {} });
      } catch (e) {
        this.setState({ loading: false, sucesso: false, errors: (e.data && e.data.errors) || {} });
      }
    }
  };

  disabledFields = () => {
    return (
      this.state.loadingResponsavel ||
      this.state.responsavelExists ||
      !this.state.unidade.responsavel.documento ||
      (!FormValidator.isCpf(this.state.unidade.responsavel.documento) &&
        this.state.unidade.responsavel.tipoDocumento === 'CPF') ||
      (!FormValidator.isCnpj(this.state.unidade.responsavel.documento) &&
        this.state.unidade.responsavel.tipoDocumento === 'CNPJ')
    );
  };

  deveRedirecionar = () => {
    let result = false;
    if (Object.keys(this.state.condominio).length > 0) {
      if (this.props.usuario.tipo === 'demo') {
        result = !this.state.habilitado;
      } else {
        result = this.state.condominio.totalUnidades === this.state.condominio.countUnidades;
      }
    }
    return result;
  };

  render() {
    const {
      unidade,
      errors,
      errorsResponsavel,
      loading,
      loadingResponsavel,
      sucesso,
      responsavelExists,
      condominio,
    } = this.state;
    const voltar = `/condominios/${condominio._id || this.props.match.params.id}/unidades`;

    return (
      <div>
        {this.deveRedirecionar() && this.props.history.goBack()}
        {!!errors.global && <Redirect to='/' />}
        <MenuHorizontal />
        <div className='corpo-dashboard'>
          <MenuVertical condominio={condominio} loading={loading} />
          <div className='va-imp-pagina'>
            <CabecalhoForm
              voltar={voltar}
              voltarTexto='Unidades votantes'
              titulo='Cadastrar unidade votante'
              descricao='Informe a unidade e o proprietário. O token de acesso ao aplicativo é gerado automaticamente.'
            />
            {!!errors.error && <Erro text={errors.error} tipo='block' />}

            {sucesso && (
              <div className='va-res-banner sucesso' role='status'>
                <Icon name='check circle outline' size='big' />
                <div>
                  <b>Unidade votante cadastrada com sucesso</b>
                  <p>Você já pode enviar o token de acesso ao proprietário na tela de edição da unidade.</p>
                  <div className='va-res-acoes'>
                    <Link to={voltar} className='ui button btn-ui-1 small'><Icon name='home' /> Voltar para as unidades</Link>
                  </div>
                </div>
              </div>
            )}

            {!sucesso && (
              <Form onSubmit={this.onSubmitCadastrar} loading={loading} autoComplete='off' className='va-imp'>
                <SecaoForm icone='home' titulo='Dados da unidade'>
                  <Form.Group widths='equal'>
                    <Form.Field error={!!errors.bloco}>
                      <label htmlFor='bloco'>Bloco/Grupo <small>(opcional)</small></label>
                      <Input id='bloco' name='bloco' type='text' placeholder='Ex.: A' onChange={this.onChange} value={unidade.bloco} />
                      <Erro text={errors.bloco} />
                    </Form.Field>
                    <Form.Field error={!!errors.numero} required>
                      <label htmlFor='numero'>Número/Identificador</label>
                      <Input id='numero' name='numero' type='text' placeholder='Ex.: 101' onChange={this.onChange} value={unidade.numero} />
                      <Erro text={errors.numero} />
                    </Form.Field>
                    {condominio.usarFracaoIdeal && (
                      <Form.Field error={!!errors.fracao} required>
                        <label htmlFor='fracao'>Fração ideal</label>
                        <Input id='fracao' name='fracao' type='number' min={0.0000000001} step={0.0000000001} max={1} placeholder='Ex.: 0.05' onChange={this.onChange} value={unidade.fracao} />
                        <Erro text={errors.fracao} />
                      </Form.Field>
                    )}
                  </Form.Group>
                  <OpcaoForm
                    ativa={unidade.enviarTokenEmail}
                    onChange={this.onChangeTokenEmail}
                    titulo='Enviar o token por e-mail ao cadastrar'
                    descricao='O proprietário recebe o token de acesso assim que a unidade for cadastrada.'
                  />
                  <Erro text={errors.enviarTokenEmail} />
                </SecaoForm>

                <SecaoForm icone='user outline' titulo='Proprietário/Associado' descricao='Digite o documento: se a pessoa já estiver cadastrada, os dados são preenchidos sozinhos.'>
                  {!!errorsResponsavel.responsavel && (
                    <AvisoForm tipo='atencao'>Não encontramos um proprietário com esse documento. Complete os dados abaixo para cadastrá-lo.</AvisoForm>
                  )}
                  {!!loadingResponsavel && <AvisoForm icone='spinner'>Buscando proprietário...</AvisoForm>}
                  {!!responsavelExists && <AvisoForm tipo='ok' icone='check circle'>Proprietário encontrado — os dados foram preenchidos.</AvisoForm>}
                  <Form.Group widths='equal'>
                    <Form.Field error={!!errorsResponsavel.documento || !!errors.documento} required>
                      <label htmlFor='documento'>Documento (CPF ou CNPJ)</label>
                      <Input
                        type='text'
                        value={unidade.responsavel.documento}
                        children={
                          <InputMask
                            id='documento'
                            name='documento'
                            placeholder='CPF ou CNPJ'
                            onInput={this.onChangeResponsavel}
                            mask={unidade.responsavel.tipoDocumento === 'CPF' ? [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/] : [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                            guide={true}
                          />
                        }
                      />
                      <Erro text={errorsResponsavel.documento || errors.documento} />
                    </Form.Field>
                    <Form.Field error={!!errors.nome} required>
                      <label htmlFor='nome'>Nome completo</label>
                      <Input id='nome' name='nome' type='text' placeholder='Nome do proprietário' onChange={this.onChangeResponsavel} value={unidade.responsavel.nome} loading={loadingResponsavel} disabled={this.disabledFields()} />
                      <Erro text={errors.nome} />
                    </Form.Field>
                  </Form.Group>
                  {!responsavelExists && (
                    <Form.Group widths='equal'>
                      <Form.Field error={!!errors.celular}>
                        <label htmlFor='celular'>Celular</label>
                        <InputMask
                          type='text'
                          id='celular'
                          name='celular'
                          placeholder='(ddd) número'
                          mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                          guide={true}
                          onChange={this.onChangeResponsavel}
                          value={unidade.responsavel.celular}
                          disabled={this.disabledFields()}
                        />
                        <Erro text={errors.celular} />
                      </Form.Field>
                      <Form.Field error={!!errors.email}>
                        <label htmlFor='email'>E-mail</label>
                        <Input id='email' name='email' type='text' placeholder='E-mail' onChange={this.onChangeResponsavel} value={unidade.responsavel.email} disabled={this.disabledFields()} />
                        <Erro text={errors.email} />
                      </Form.Field>
                    </Form.Group>
                  )}
                </SecaoForm>

                <RodapeForm>
                  <Button type='submit' loading={loading} disabled={loading} className='btn-ui-1' size='large'>
                    <Icon name='save' /> Cadastrar unidade votante
                  </Button>
                  <Link to={voltar} className='ui basic large button'>Cancelar</Link>
                </RodapeForm>
              </Form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    unidade: state.unidade.unidade,
    unidades: state.unidade.unidades,
    responsavel: state.responsavel.responsavel,
    tiposDocumentos: state.responsavel.tiposDocumentos,
    usuario: state.user.user,
    errors: state.unidade.errors,
    errorsResponsavel: state.responsavel.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create,
      findResponsavelByDocumento,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarUnidade);
